import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M3 8.777a1 1 0 0 1 .5-.866l8-4.622a1 1 0 0 1 1 0l8 4.622a1 1 0 0 1 .5.866V10a1 1 0 0 1-1 1h-1v7h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h1v-7H4a1 1 0 0 1-1-1V8.777ZM8 11v7h2.5v-7H8Zm5.5 0v7H16v-7h-2.5Zm0-3.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
      clip-rule="evenodd"
    />
  </svg>
`;
